import { render, staticRenderFns } from "./marriot.vue?vue&type=template&id=8170c87a&scoped=true&"
import script from "./marriot.vue?vue&type=script&lang=js&"
export * from "./marriot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8170c87a",
  null
  
)

export default component.exports